<script lang="ts">
import { sanitizeRichTextHtml } from '$lib/utils/sanitise';
import { prepareHtmlLinks } from '$lib/utils/url';

interface Props {
    text?: string;
}

let { text = '' }: Props = $props();

const sanitisedText = $derived(prepareHtmlLinks(sanitizeRichTextHtml(text)));
</script>

<div class="html-text">
    {@html sanitisedText}
</div>

<style lang="scss">
    @use "/src/scss/global-constants/typography";
    @use "/src/scss/mixins/builder-rich-text" as builder-mixins;

    .html-text {
        display: flex;
        flex-direction: column;
        gap: 2rem;

        @include builder-mixins.rich-text-links;

        :global(.h5),
        :global(h5) {
            @include typography.h5;
        }

        :global(p) {
            @include typography.body-base;
        }
    }
</style>
